/**
 * Point d'entrée pour la bannière GDPR
 * Boss SEO Plugin
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { GDPRConsentBanner } from './components/privacy';

// Styles pour la bannière GDPR
import './styles/gdpr-banner.scss';

// Initialiser la bannière GDPR
document.addEventListener('DOMContentLoaded', function() {
    const bannerContainer = document.getElementById('boss-gdpr-banner-root');
    
    if (bannerContainer && window.bossGdprData && !bannerContainer._reactRoot) {
        try {
            const root = createRoot(bannerContainer);
            bannerContainer._reactRoot = root;
            root.render(<GDPRConsentBanner />);
            
        } catch (error) {
            
        }
    }
});
